import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { User } from '../../../../../models/user.model';
import { UserService } from '../../../../../services/user.service';
import {SuggestionListsService} from '../../services/suggestion-lists.service';


@Component({
  selector: 'app-my-suggestion-lists',
  templateUrl: './my-suggestion-lists.component.html',
  styleUrls: ['./my-suggestion-lists.component.css']
})
export class MySuggestionListsComponent implements OnInit, OnDestroy {
  activeList = 1;
  
	user: User;
	isAdmin = false;
	isUser = false;
	isHead = false;


  constructor(private router: Router,
              private route: ActivatedRoute,
              public suggestionListsService: SuggestionListsService,
              public userService: UserService) {
  }

  ngOnDestroy() {
    this.suggestionListsService.showSuccessMsgOnSLList = false;
  }

  ngOnInit() {
    if (this.router.url.includes('my-lists')) {
      this.activeList = 1;
    } else if (this.router.url.includes('my-drafts')) {
      this.activeList = 2;
    } else {
      this.activeList = 1;
    }
    this.checkRole();
  }

  checkRole() {
		this.user = this.userService.getLocal();
		if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
			this.isHead = true;
		} else {
			this.isHead = false;
		}
		if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
			this.isAdmin = true;
		} else {
			this.isAdmin = false;
		}
		if (this.user.roles.indexOf('ROLE_USER') !== -1) {
			this.isUser = true;
		} else {
			this.isUser = false;
		}
	}

  goToCreateNewSL() {
    this.suggestionListsService.setListType('free');
    this.router.navigate(['/dashboard/create-suggestion-list']);
  }

  setActiveList(listNumber) {
    this.activeList = listNumber;

    switch (listNumber) {
      case 1:
        this.router.navigate(['/dashboard/my-suggestion-lists/my-lists']);
        break;
      case 2:
        this.router.navigate(['/dashboard/my-suggestion-lists/all-suggestion-lists']);
        break;
      case 3:
        this.router.navigate(['/dashboard/my-suggestion-lists/for-review-suggestion-lists']);
        break;
      case 4:
        this.router.navigate(['/dashboard/my-suggestion-lists/all-suggestion-lists']);
        break;
      default:
        this.router.navigate(['/dashboard/my-suggestion-lists/my-lists']);
        break;
    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/suggestion-lists/components/my-suggestion-lists/my-suggestion-lists.component.ts